/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_A3dInputs */

const en_mk_sol_konsultan_a3d = /** @type {(inputs: Mk_Sol_Konsultan_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers “have we done something like this before?” from the workspace’s whole history.`)
};

const id_mk_sol_konsultan_a3d = /** @type {(inputs: Mk_Sol_Konsultan_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjawab "apakah kita pernah mengerjakan yang seperti ini?" dari seluruh riwayat workspace.`)
};

/**
* | output |
* | --- |
* | "Answers “have we done something like this before?” from the workspace’s whole history." |
*
* @param {Mk_Sol_Konsultan_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_a3d = /** @type {((inputs?: Mk_Sol_Konsultan_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_a3d(inputs)
	return en_mk_sol_konsultan_a3d(inputs)
});